// 角度换算工具函数

export function rad2deg(rad) {
  return 180 * rad / Math.PI
}

export function deg2rad(deg) {
  return (deg * Math.PI) / 180
}
